<template>
  <modal
    :title="branch.Name + ' Branch Users'"
    :size="'xl'"
    @close="$emit('close')"
  >
    <template #content>
      <div
        class="head row m-0 border-bottom p-t-5 p-l-5 p-r-5 p-b-5 align-items-center justify-content-end"
      >
        <div class="col-xs-12 col-sm-auto p-t-5 p-b-5">
          <button
            class="btn btn-info btn-icon waves-effect waves-light p-r-20 m-l-5"
            type="button"
            @click="addShow = true"
            :key="index"
          >
            <span class="btn-label m-0 p-0"><i class="fa fa-plus"></i></span>
            <span class="p-l-20 p-r-10">Add User</span>
          </button>
        </div>
      </div>
      <dataTable
        :name="'BranchUsers'"
        ref="agGrid"
        :data="data"
        @update="updateShow = { ...$event }"
        @remove="remove"
      ></dataTable>
    </template>
  </modal>
  <add
    v-if="addShow"
    @close="addShow = false"
    :BranchId="branch.Id"
    @add="$refs.agGrid.addRow([$event])"
  ></add>
  <update
    v-if="updateShow != null"
    :setModel="updateShow"
    @update="$refs.agGrid.changeRow('Id', $event)"
    @close="updateShow = null"
  ></update>
</template>

<script>
import add from "./add";
import update from "./update";
export default {
  props: {
    branch: Object,
  },
  components: { add, update },
  data() {
    return {
      data: null,
      addShow: false,
      updateShow: null,
    };
  },
  created() {
    this.$appAxiosAdmin
      .get(`Branchs/` + this.branch.Id + `/Users`)
      .then((response) => {
        this.data = response.data;
      });
  },
  methods: {
    remove(item) {
      this.$swal({
        icon: "question",
        title: "Warning!",
        text:
          "Are you sure you want to delete the branch user named " +
          item.Name +
          "?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (question.isConfirmed) {
          this.$appAxiosAdmin
            .delete(`Users/` + item.Id)
            .then(() => {
              this.$refs.agGrid.removeRow([item]);
              this.$swal({
                icon: "success",
                title: "Success",
                text: "The branch user has been successfully deleted.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>

<style></style>
